
<div class="row">
  <div class="col-md-4 offset-md-4 d-flex justify-content-center">
    <h1>Login</h1>
  </div> 
</div>

<div class="row">
  <div class="col-md-4 offset-md-4 border shadow p-3 mb-5 rounded-lg">
    <form>
      <div class="form-group">
        <mat-form-field>
          <mat-label>Email address</mat-label> 
          <input matInput type="text" [(ngModel)]="email" name="email" id="email" class="form-control">
        </mat-form-field>
      </div>
      <div class="form-group">
        <mat-form-field>
          <mat-label>Password</mat-label> 
          <input matInput type="password" class="form-control" name="password" [(ngModel)]="password" id="password">
        </mat-form-field>
      </div>

      <div *ngIf="error">{{ errorMessage }}</div>

      <div class="text-right">
        <a color="info"  routerLink="/retrieve" class="m-2">Forgot your password?</a>
        <button mat-raised-button (click)="login()" type="submit" color="accent">Submit</button>
        <mat-spinner diameter="30" *ngIf='loading'></mat-spinner>
      </div>

    </form>
  </div>
</div>


